var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"javascript:void"},on:{"click":_vm.downloadFile}},[_vm._v(_vm._s(_vm.currentModel != null ? _vm.currentModel.originalFilename : ""))])])
}
var staticRenderFns = []

export { render, staticRenderFns }